
/**
 * 큰 숫자를 한국인이 읽기 쉬운 '억', '만' 단위로 포맷팅합니다.
 * 만원 단위 미만은 절사합니다.
 * @param {number} number - 포맷팅할 숫자 (예: 12370000000)
 * @returns {string} - 포맷팅된 문자열 (예: "123억 7,000만 원")
 */
export function formatSignificantTwoDigitsGrouped(number) {
    if (typeof number !== 'number' || isNaN(number)) {
        return "유효하지 않은 숫자";
    }

    // 만원 단위 미만 절사
    const truncated = Math.floor(Math.abs(number) / 10000) * 10000;
    
    if (truncated === 0) {
        return '0원';
    }

    const units = ['', '만', '억', '조', '경'];
    let result = [];
    let remaining = truncated;
    let unitIndex = 0;

    // 4자리(만) 단위로 반복
    while (remaining > 0) {
        // 현재 단위의 4자리 숫자 (예: 1234, 5678)
        let chunk = remaining % 10000;
        
        if (chunk > 0) {
            let formattedChunk = chunk.toLocaleString('ko-KR'); 
            result.unshift(`${formattedChunk}${units[unitIndex]}`);
        }
        
        remaining = Math.floor(remaining / 10000);
        unitIndex++;
    }

    if (result.length === 0) {
        return '0원';
    }

    return result.join(' ') + ' 원';
}





